import { Injectable, inject } from '@angular/core';

import type { Observable } from 'rxjs';

import { AsyncJobService } from '@core/async-job-data';
import type { BulkOfferResponse } from '@core/bulk-actions-types';
import { HttpApiService } from '@core/http-legacy';

export interface Ids {
  ids: number[];
}

@Injectable({ providedIn: 'root' })
export class BulkActionsHttpClient {
  protected readonly httpApi = inject(HttpApiService);
  protected readonly asyncJob = inject(AsyncJobService);

  public follow({ ids }: Ids): Observable<BulkOfferResponse> {
    return this.httpApi.patch(`/bulk/offers/follow`, null, { offers_ids: ids });
  }

  public unfollow({ ids }: Ids): Observable<BulkOfferResponse> {
    return this.httpApi.patch(`/bulk/offers/unfollow`, null, { offers_ids: ids });
  }

  public deleteArchived({ ids }: Ids): Observable<BulkOfferResponse> {
    return this.httpApi.patch(`/bulk/offers/delete_archived`, null, { offers_ids: ids });
  }

  public retrieveArchived({ ids }: Ids): Observable<BulkOfferResponse> {
    return this.httpApi.patch(`/bulk/offers/retrieve_archived`, null, { offers_ids: ids });
  }

  public enableReferrals({ ids }: Ids): Observable<BulkOfferResponse> {
    return this.httpApi.patch('/bulk/offers/enable_referral_program', null, { offers_ids: ids });
  }

  public disableReferrals({ ids }: Ids): Observable<BulkOfferResponse> {
    return this.httpApi.patch('/bulk/offers/disable_referral_program', null, { offers_ids: ids });
  }
}
